var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.groups.includes('dhd | demo integratie'))?_c('div',{attrs:{"id":"app"}},[_c('IntegratedCodePicker')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }